import { connect } from 'react-redux';
import PublicRoute from './PublicRoute'

const mapStateToProps = (state, props) => {
 
    return {
	authenticated: state.session.authenticated
    }
}

const mapDispatchToProps = (dispatch, state) => {
    return {

    }
}

const PublicRouteContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(PublicRoute);




export default PublicRouteContainer;



// WEBPACK FOOTER //
// ./src/utils/PublicRoute/Container.js